var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.55 21.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.62,21.12c5.77,0,11-4.71,11-10.47A10.78,10.78,0,0,0,15.62,0h-5A10.42,10.42,0,0,0,0,10.65,10.58,10.58,0,0,0,10.65,21.12Z",
    style: {
      fill: "#004a98"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.87,16.26V4.82a6.13,6.13,0,0,1,0,11.44M4.55,10.54A6.13,6.13,0,0,1,8.48,4.82V16.26a6.13,6.13,0,0,1-3.93-5.72M10.67.87a9.67,9.67,0,1,0,9.67,9.67A9.67,9.67,0,0,0,10.67.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,13.17c0,.86.61,1,1.16,1,2.4,0,3.18-1.81,3.18-3.47a3.33,3.33,0,0,0-3.47-3.57c-.46,0-.67,0-.87,0ZM30.23,8c0-1-.52-.93-1-.94V6.73c.44,0,.88,0,1.31,0l1.92,0c2.88,0,4.45,1.92,4.45,3.89,0,1.1-.65,3.86-4.58,3.86l-1.61,0-1.49,0v-.29c.67-.06,1-.08,1-.84Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.47,7.7a.58.58,0,0,1-.55-.56.57.57,0,0,1,.55-.53.54.54,0,0,1,.54.53.56.56,0,0,1-.54.56m-1.19,6.49h.21c.31,0,.53,0,.53-.36v-3c0-.49-.17-.56-.58-.78V9.86a9.88,9.88,0,0,0,1.19-.4.45.45,0,0,1,.2-.05c.06,0,.08.06.08.15v4.27c0,.36.24.36.55.36h.19v.29l-1.16,0-1.21,0Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.71,10.88c0-.41-.12-.52-.65-.73V9.94a14,14,0,0,0,1.47-.53s.07,0,.07.11v.72a3.25,3.25,0,0,1,1.92-.83c.94,0,1.28.69,1.28,1.55v2.87c0,.36.24.36.55.36h.2v.29l-1.18,0-1.2,0v-.29h.2c.32,0,.54,0,.54-.36V11c0-.63-.39-.94-1-.94a3,3,0,0,0-1.29.53v3.29c0,.36.24.36.55.36h.2v.29l-1.18,0-1.19,0v-.29h.2c.31,0,.53,0,.53-.36Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.36,11.06c.28,0,.31-.14.31-.28a.94.94,0,0,0-1-1c-.68,0-1.15.5-1.28,1.3Zm-2,.36a2,2,0,0,0,0,.64A1.84,1.84,0,0,0,48,14a2.13,2.13,0,0,0,1.5-.74l.15.15a2.59,2.59,0,0,1-2,1.26,2.23,2.23,0,0,1-2.12-2.42c0-2.18,1.46-2.82,2.24-2.82a1.76,1.76,0,0,1,1.88,1.74,1.34,1.34,0,0,1,0,.2l-.1.07Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.88,14.19h.3c.31,0,.54,0,.54-.36V10.71c0-.35-.41-.41-.58-.5V10c.81-.34,1.25-.63,1.36-.63s.09,0,.09.14v1h0c.27-.43.74-1.14,1.42-1.14a.6.6,0,0,1,.63.59.53.53,0,0,1-.52.56c-.35,0-.35-.26-.73-.26a.93.93,0,0,0-.81.92v2.61c0,.36.22.36.53.36h.62v.29l-1.55,0-1.33,0Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.16,12.94a1.46,1.46,0,0,0,1.4,1.35.79.79,0,0,0,.9-.78c0-1.31-2.42-.89-2.42-2.68a1.53,1.53,0,0,1,1.72-1.42A3,3,0,0,1,57,9.73l.07,1.13h-.25a1.14,1.14,0,0,0-1.21-1.1.78.78,0,0,0-.87.74c0,1.3,2.58.89,2.58,2.64,0,.73-.59,1.51-1.91,1.51a3,3,0,0,1-1.36-.38L54,13Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.38,8.74H67.1a2.11,2.11,0,0,0-2.38-1.82,3.16,3.16,0,0,0-3.13,3.52,3.62,3.62,0,0,0,3.31,3.85,2.25,2.25,0,0,0,2.23-1.92l.26.07-.26,1.62a6.18,6.18,0,0,1-2.45.59,4,4,0,0,1-4.24-4.18,4.09,4.09,0,0,1,4.21-3.91,8,8,0,0,1,2.62.59Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.78,14.19H68c.31,0,.53,0,.53-.36V7.64c0-.72-.16-.74-.59-.87V6.6a8.18,8.18,0,0,0,1.15-.48A1,1,0,0,1,69.32,6c.07,0,.09.06.09.15v7.68c0,.36.25.36.56.36h.18v.29l-1.16,0-1.21,0Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.91,13.87c0,.2.12.21.31.21h.45v.24a10.31,10.31,0,0,0-1.6.34l-.06,0v-.9a3,3,0,0,1-2,.93,1.2,1.2,0,0,1-1.22-1.32V10.48c0-.28,0-.56-.66-.62V9.65c.4,0,1.28-.08,1.43-.08s.12.08.12.33v2.86c0,.33,0,1.29,1,1.29A2.5,2.5,0,0,0,74,13.37v-3c0-.22-.53-.34-.93-.45v-.2c1-.07,1.62-.16,1.73-.16s.09.08.09.2Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,13.23a1.19,1.19,0,0,0,1.14,1.13c1.19,0,1.69-1.17,1.69-2.15A2.12,2.12,0,0,0,78.18,10a1.68,1.68,0,0,0-1.06.52Zm0-3a2.77,2.77,0,0,1,1.66-.8,2.16,2.16,0,0,1,2.06,2.33,2.81,2.81,0,0,1-2.65,2.91,3.3,3.3,0,0,1-1.55-.39l-.33.26-.23-.13a12.87,12.87,0,0,0,.15-2V7.64c0-.72-.17-.74-.59-.87V6.6a8.18,8.18,0,0,0,1.15-.48A1,1,0,0,1,77,6c.07,0,.09.06.09.15Z",
    style: {
      fill: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.72,8.82h.09c.09,0,.13-.07.13-.19s-.06-.15-.14-.15h-.08Zm-.24.37v0c.09,0,.1,0,.1-.06V8.57c0-.08,0-.1-.1-.1v0h.37c.13,0,.24.06.24.19a.23.23,0,0,1-.17.22L81,9a.53.53,0,0,0,.16.17v0h-.14c-.07,0-.13-.14-.26-.33h-.08V9.1c0,.05,0,.05.11.06v0Zm.36.21a.59.59,0,1,0-.57-.58.58.58,0,0,0,.57.58m0-1.3a.72.72,0,1,1-.72.72.7.7,0,0,1,.72-.72",
    style: {
      fill: "#1d1d1b"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.869c4ef2.svg";
export { ForwardRef as ReactComponent };